import { render, staticRenderFns } from "./currencyIndex.pug?vue&type=template&id=05f390d1&lang=pug&"
import script from "./currencyIndex.ts?vue&type=script&lang=ts&"
export * from "./currencyIndex.ts?vue&type=script&lang=ts&"
import style0 from "./currencyIndex.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports